<script>
import { defineComponent } from 'vue';
import FeedbackCenterList from '@/components/feedback-center-list';
import { request } from '@/plugins/plugin-request';
import I18n from '@/i18n/locale';

export default defineComponent({
  setup() {
    function questionClick(type) {
      switch (type) {
        case 'send':
          FeedbackCenterList.sendOpen(request);
          break;
        case 'view':
          FeedbackCenterList.viewOpen(request);
          break;
      }
    }

    return () => {
      return (
        <pb-dropdown onCommand={questionClick}>
          <span class="gtr-tools-icon">
            <i class="gattaran-wentifankui"></i>
          </span>
          <pb-dropdown-menu slot="dropdown">
            <pb-dropdown-item command="send">{I18n.t('sailing.dilu.newfeedback' /*问题反馈*/)}</pb-dropdown-item>
            <pb-dropdown-item command="view">{I18n.t('sailing.dilu.myfeedback' /*我的反馈*/)}</pb-dropdown-item>
          </pb-dropdown-menu>
        </pb-dropdown>
      );
    };
  },
  methods: {},
});
</script>
<style lang="scss" scoped>
@import '../style';

.gtr-tools-icon {
  @extend .gtr-header_tool_icons;
}

.gattaran-wentifankui {
  color: #c2c4cc;
  font-size: 16px !important;

  &:hover {
    background: #595c66;
    color: #fff;
  }
}

@media screen and (max-width: $checkMobileMaxWidth) {
  .gtr-tools-icon {
    display: none !important;
  }
}
</style>
